// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".complie-prompt[data-v-566b8e9b]{padding-bottom:0}.complie-prompt-con[data-v-566b8e9b]{width:100%;height:50px;margin-bottom:10px;background:#fff2e8}.complie-prompt-con .ico-prompt[data-v-566b8e9b]{margin:16px 15px 0 30px}.complie-prompt-con .complie-prompt-text[data-v-566b8e9b]{width:700px;font-size:14px;line-height:50px}.complie-prompt-con .g-btn[data-v-566b8e9b]{margin-top:10px;margin-right:30px}.complie-prompt-con .g-btn[data-v-566b8e9b]:hover{background:#ffe4d0}", ""]);
// Exports
module.exports = exports;
